import React, { useEffect, useState } from 'react';
import Header from '../StudentSessionReport/components/Header';
import ReportOptions from '../StudentSessionReport/components/ReportOptions';
import Table from '../StudentSessionReport/components/Table';
import Totals from '../StudentSessionReport/components/Totals';
import IndividualQuestionTable from './IndividualQuestionTable';
import IndividualQuestionTableVertical from './IndividualQuestionTableVertical';
import { useLocation, useParams } from 'react-router-dom';
import {
  useGetSessionReportOptionsMutation,
  useSetReportOptionsMutation
} from '../../../../../../features/authentication/reportApiSlice';
import CustomToast from '../../../../../../components/Toast';
import {
  capitalizeFirstLetter,
  convertHtmlToPlainText,
  convertToCSV,
  cumilativeMainTotalTable,
  cumilativeReportTotals,
  allCumilativeReportTotals,
  cumulativeIndividualScore,
  downloadCSV,
  mergeObjectsByNumber,
  mergeObjectsByNumberforExport,
  removePropertiesFromObjects,
  reorderObjectProperties,
  reportOptionsBasedScoreCalculation,
  teacherCumilativeMainTotalTable
} from '../../../../utils';
import { useSelector } from 'react-redux';
import { selectFerpaState } from '../../../../../../features/authentication/authSlice';
import Skeleton from 'react-loading-skeleton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Form } from 'react-bootstrap';
import { useReportContext } from '../../../../../reports/components/reportContext';
import PropTypes from 'prop-types';
import SkeletonGrid from '../../../../../../components/SkeletonLoader/SkeletonGrid';
import TableSkeleton from '../../../../../../components/SkeletonLoader/TableSkeleton';
import { DateFormatter } from '../../../../../../utils/DateFormatter';
import { useGetClassesMutation } from '../../../../../../features/authentication/authApiSlice';
import usePrintPdfGenerator from '../../../../../../utils/PrintPdfGenerator';
import PageSize from '../../../../../../enums/pageSize';
import { addCustomCheckboxClass } from '../../../../../../utils/pdfUtils';

const QuestionsBreakdownReport = ({
  isRetakeReport,
  studentId,
  initialClassId,
  exportFileName,
  reportDataEndpoint,
  individualResultsOrientation,
  isTeacherReport,
  headerOptions,
  studentToIncludeTab,
  reportOptions,
  retryCreditId,
  goBackOnError
}) => {
  const [expand, setExpand] = useState(false);
  const [sessionReportOptions, setSessionReportOptions] = useState([]);
  const [changingReportOptions, setChangingReportOptions] = useState(false);
  const [selectedClassIds, setSelectedClassIds] = useState(-1);
  const [classList, setClassList] = useState([]);
  const [cumilativeReportData, setCumilativeReportData] = useState(null);
  const ferpaEnabled = useSelector(selectFerpaState);
  const [updatedData, setUpdatedData] = useState([]);
  const [copyData, setCopyData] = useState(null);
  const [selectedCreditId, setSelectedCreditId] = useState(1);
  const [loader, setLoader] = useState(false);
  const [reportOptionloader, setReportOptionloader] = useState(false);
  const [showReportOptions, setShowReportOptions] = useState(true);
  const [mainTotalTableData, setMainTotalTableData] = useState(null);
  const { Id } = useParams();
  const [creditName, setCreditName] = useState('No Credits');
  const [showRetryOptions, setShowRetryOptions] = useState(true);
  const [isMounted, setIsMounted] = useState(false);

  const [setReportOptions] = useSetReportOptionsMutation();
  const [getSessionReportOptions] = useGetSessionReportOptionsMutation();
  const [excludedStudents, setExcludedStudents] = useState([]);
  const [displayRetakeVersion, setDisplayRetakeVersion] = useState('original');
  const [dateTimeBasedUniqueKey, setDateTimeBasedUniqueKey] = useState(
    new Date().getTime().toString()
  );
  const reportContext = useReportContext();
  const [questionCategory, setQuestionCategory] = useState(0);
  const [assignmentNotStarted, setAssignmentNotStarted] = useState(false);
  const [expandElements, setExpandElements] = useState([]);
  const [getAllClasses] = useGetClassesMutation();
  const { printPDF, isPdfGenerating } = usePrintPdfGenerator();
  const location = useLocation();
  const selfStudyFilters = location.state?.filters || {};
  const propertyKeys = [
    'questions',
    'totals',
    'topics',
    'tags',
    'levels',
    'attributes',
    'standards'
  ];

  useEffect(() => {
    if (isTeacherReport && (studentToIncludeTab !== 2)) {
      fetchCumulativeAssignmentReport(reportContext?.isAllReport ? reportContext?.selectedClassIds : reportContext?.selectedClassId);
      setSelectedClassIds(reportContext?.isAllReport ? reportContext?.selectedClassIds : reportContext?.selectedClassId);
    }
    else {
      if (initialClassId) setSelectedClassIds(initialClassId);
      else setSelectedClassIds(-1);
      fetchCumulativeAssignmentReport(initialClassId ?? -1);
    }
    if(headerOptions?.showClassDropdown) fetchClassList();
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (changingReportOptions) {
      optionReportHandler();
    }
    setSelectedCreditId(sessionReportOptions?.correctOnRetry);
    allCredits.map((credit) => {
      if (credit.id == sessionReportOptions?.correctOnRetry) {
        setCreditName(credit.name);
      }
    });
    if (cumilativeReportData && sessionReportOptions) {
      setCumilativeReportData(
        cumulativeIndividualScore(cumilativeReportData, sessionReportOptions)
      );
    }
  }, [sessionReportOptions]);

  useEffect(() => {
    let updatedQuestionProperties;
    if (cumilativeReportData && cumilativeReportData.properties && sessionReportOptions) {
      var copiedReportData = { ...cumilativeReportData };
      if (isRetakeReport)
      {
        copiedReportData.properties = displayRetakeVersion == 'original' ? copiedReportData.properties : copiedReportData.bestRetakeProperties;
        if(headerOptions.reportTitle == 'Class Retake Report' && displayRetakeVersion == 'bestScore')
          copiedReportData.studentResults = cumilativeReportData.bestResults;
      }

      updatedQuestionProperties = reportOptionsBasedScoreCalculation(
        copiedReportData.properties.questionProperties,
        sessionReportOptions
      );
      const questions = copiedReportData?.properties?.questions.map((item) => {
        return {
          ...item,
          inCorrect: sessionReportOptions?.scoreStartedNotCompletedIncorrect
            ? item.inCorrect + item.notAnswered
            : item.inCorrect,
          crAnswered: sessionReportOptions?.scoreUnscoredCRZero
            ? item.crAnswered + item.crNotAnswered
            : item.crAnswered
        };
      });
      updatedQuestionProperties[0].questions = questions;

      let value = {};
      if (isTeacherReport && reportContext?.isAllReport && copiedReportData.properties.questionProperties.length > 1) {
        value = allCumilativeReportTotals(copiedReportData.properties.questionProperties, sessionReportOptions, selectedCreditId);
        updateCourseTableData(updatedQuestionProperties, value);
        return;
      }
      else
        value = cumilativeReportTotals(copiedReportData, sessionReportOptions);
      const updatedData1 = updatedQuestionProperties?.map((course) => {
        if (course.courseName === 'Teacher Questions - Short Answer ') {
          return {
            ...course,
            totals: value.teacherQuestionReport
          };
        } else if (course.courseName !== 'Teacher Questions - Multiple Choice ') {
          return {
            ...course,
            totals: value.courseReport
          };
        }
      });
      setCopyData(updatedData1);
      addTableElementIds(updatedData1);
    }
  }, [cumilativeReportData, sessionReportOptions, displayRetakeVersion]);

  const updateCourseTableData = (updatedQuestionProperties, value) => {
    const updatedDataCourseData = updatedQuestionProperties?.map((course) => {
      if (course.courseName === 'Teacher Questions - Short Answer ') {
        return {
          ...course,
          totals: value.teacherQuestionReportSA
        };
      }
      else if (course.courseName === 'Teacher Questions - Constructed Response') {
        return {
          ...course,
          totals: value.teacherQuestionReportCR
        };
      } else if (course.courseName !== 'Teacher Questions - Multiple Choice ') {
        return {
          ...course,
          totals: value.courseReport
        };
      }
    });
    setCopyData(updatedDataCourseData);
    addTableElementIds(updatedDataCourseData);
  };

  const addTableElementIds = (data) => {
    const elementIds = data.flatMap((_, index) =>
      propertyKeys.map(key => `${key}_${index}`)
    );

    setExpandElements(elementIds);
  };

  useEffect(() => {
    var copiedReportData = { ...cumilativeReportData };
    if (isRetakeReport) {
      copiedReportData.studentResults = copiedReportData?.studentResults?.filter(r => displayRetakeVersion == 'original' ? r.originalAssignment : r.bestScore);
    }
    if (cumilativeReportData && cumilativeReportData.properties && sessionReportOptions) {
      let totalTableData = {};
      if (isTeacherReport && reportContext?.isAllReport) {
        totalTableData = teacherCumilativeMainTotalTable(
          copiedReportData.properties.totals,
          sessionReportOptions,
          selectedCreditId
        );
      }
      else {
        if(headerOptions.reportTitle == 'Class Retake Report' && displayRetakeVersion == 'bestScore'){
          let newReportData = {...cumilativeReportData, studentResults : cumilativeReportData.bestResults};
          copiedReportData = cumulativeIndividualScore(newReportData,sessionReportOptions);
        }

        totalTableData = cumilativeMainTotalTable(
          copiedReportData,
          sessionReportOptions,
          headerOptions.reportTitle
        );
      }
      setMainTotalTableData(totalTableData);
      excludedStudentsHandler();
    }
  }, [cumilativeReportData, sessionReportOptions, displayRetakeVersion]);

  useEffect(() => {
    if (!loader && isMounted) {
      getAllCumulativeReportData(questionCategory);
    }
  }, [reportContext?.startDate, reportContext?.endDate]);

  const fetchClassList = async () => {
    let classes = localStorage.getItem('classes');
    if (classes) {
      classes = JSON.parse(classes);
    }else
    {
      classes = await getAllClasses().unwrap();
      localStorage.setItem('classes', JSON.stringify(classes));
    }
    setClassList([
      {
        name: 'All Classes',
        id: -1,
        description: 'All Classes',
        isChecked: true
      },
      ...classes.map((item) => ({
        name: item.className,
        id: item.classID,
        description: item.coTeacherClass ? item.teacherName : '',
        isChecked: true
      }))
    ]);
  };

  const handleQuestionCategory = (questionCategory) => {
    getAllCumulativeReportData(questionCategory);
  };

  const getAllCumulativeReportData = async (questionCategory) => {
    try {
      setCumilativeReportData(null);
      setCopyData(null);
      setMainTotalTableData(null);

      setLoader(true);
      const options = {
        questionCategory: questionCategory,
        studentId: reportContext?.selectedStudentId,
        classIds: reportContext?.selectedClassIds,
        isAssessment: reportContext?.isAssessment,
        startDate: reportContext?.startDate,
        endDate: reportContext?.endDate,
        courseId: reportContext?.selectedCourseId
      };
      var response = await reportDataEndpoint(options).unwrap();
      setCumilativeReportData(response);
    }
    catch (error) {
      console.log(error);
      if (typeof error.data == 'string') {
        CustomToast(error.data, 'error');
      }
      else if (error.data.errorMessage) {
        CustomToast(error.data.errorMessage, 'error');
        setCumilativeReportData({
          course: (isTeacherReport && reportContext?.isAllReport && reportContext?.courseName) ? reportContext?.courseName : error.data?.course,
          reportDate: error.data?.reportDate,
          teacher: error.data?.teacher
        });

      } else {
        CustomToast('An unknown error has occured', 'error');
      }

      if (goBackOnError) {
        window.history.back();
      } else {
        setShowReportOptions(true);
      }
    }
    setLoader(false);
  };

  const fetchCumulativeAssignmentReport = async (classId) => {
    setLoader(true);
    setReportOptionloader(true);
    setCumilativeReportData(null);
    setCopyData(null);
    setMainTotalTableData(null);
    const reportOption = {
      reportOptionType: 1,
      isRetakeReport: isRetakeReport
    };
    const reportResponse = await getSessionReportOptions(reportOption).unwrap();
    setSessionReportOptions(reportResponse);

    try {
      let response = null;
      if (isTeacherReport && reportContext?.isAllReport) {
        const options = {
          questionCategory: questionCategory,
          studentId: studentToIncludeTab == 2 ? reportContext?.selectedStudentId : 0,
          classIds: Array.isArray(classId) ? classId : [classId],
          isAssessment: reportContext?.isAssessment,
          startDate:reportContext?.startDate,
          endDate: reportContext?.endDate,
          courseId: reportContext?.selectedCourseId
        };
        response = await reportDataEndpoint(options).unwrap();
        setCumilativeReportData(response);
      }
      else {
        let option = {};
        if(headerOptions?.isSelfStudyCumulative)
        {         
          option = {
            classIds:selfStudyFilters.classIds,
            courseIds:selfStudyFilters.courseIds,
            studentIds:selfStudyFilters.studentIds
          };
        }
        else if(headerOptions?.isSelfStudy) {
          option = {
            sessionId: Id,
            studentId: studentId
          };
        } else {
          option = {
            assignmentId: Id,
            classId: classId,
            studentId: studentId
          };
        }
        response = await reportDataEndpoint(option).unwrap();
        setCumilativeReportData(cumulativeIndividualScore(response, reportResponse));
      }

      var startedStudent = response.studentResults?.find((x) => x.assignmentStarted);
      if (startedStudent == null) setAssignmentNotStarted(true);
      if(isRetakeReport){
        const updateData = {...reportResponse, passingScore: response.masteryLevel, correctOnRetry : retryCreditId != undefined ? retryCreditId + 1 : reportResponse.correctOnRetry};
        setSessionReportOptions(updateData);
      }
      else
        setSessionReportOptions(reportResponse);

      setLoader(false);
      setReportOptionloader(false);
      response !== null ? setExpand(true) : setExpand(false);
    } catch (error) {
      setLoader(false);
      setReportOptionloader(false);
      console.log(error);
      if (typeof error.data == 'string') {
        CustomToast(error.data, 'error');
      }
      else if (error.data.errorMessage) {
        CustomToast(error.data.errorMessage, 'error');
        setCumilativeReportData({
          course: (isTeacherReport && reportContext?.isAllReport && reportContext?.courseName) ? reportContext?.courseName : error.data?.course,
          reportDate: error.data?.reportDate,
          teacher: error.data?.teacher
        });

      } else {
        CustomToast('An unknown error has occured', 'error');
      }
      if (goBackOnError) {
        window.history.back();
      } else {
        setShowReportOptions(true);
      }
    }
  };

  const handleClassSelectionChange = async (e) => {
    const selectedCourseId = parseInt(e.target.value);
    setSelectedClassIds(selectedCourseId);
    await fetchCumulativeAssignmentReport(selectedCourseId);
  };

  const reportChangeHandler = (id, e) => {
    setChangingReportOptions(true);
    if (id == 'questions' && !e) {
      const updatedSessionReportOptions = {
        ...sessionReportOptions,
        [id]: !sessionReportOptions[id],
        answerDistribution: false
      };
      setSessionReportOptions(updatedSessionReportOptions);
    } else {
      const updatedSessionReportOptions = {
        ...sessionReportOptions,
        [id]: !sessionReportOptions[id]
      };
      setSessionReportOptions(updatedSessionReportOptions);
    }
    setDateTimeBasedUniqueKey(new Date().getTime().toString());
  };

  const handleCheckBonInput = (id) => {
    setChangingReportOptions(true);
    const updatedSessionReportOptions = {
      ...sessionReportOptions,
      [id]: !sessionReportOptions[id]
    };
    setSessionReportOptions(updatedSessionReportOptions);
    setDateTimeBasedUniqueKey(new Date().getTime().toString());
  };

  const handleReportDateChange = (dateValue, dateType) => {
    setChangingReportOptions(true);
    const updateSessionReportOptions = {
      ...sessionReportOptions,
      [dateType]: dateValue
    };
    setSessionReportOptions(updateSessionReportOptions);
    setDateTimeBasedUniqueKey(new Date().getTime().toString());
  };

  const handleSelectCredits = async (e) => {
    setChangingReportOptions(true);
    allCredits.map((credit) => {
      if (credit.id == parseInt(e.target.value)) {
        setCreditName(credit.name);
      }
    });
    setSelectedCreditId(parseInt(e.target.value));
    const updateData = {
      ...sessionReportOptions,
      correctOnRetry: parseInt(e.target.value)
    };
    setSessionReportOptions(updateData);
  };

  const optionReportHandler = async () => {
    const option = [
      {
        passingScore: sessionReportOptions.passingScore,
        correctOnRetry: sessionReportOptions.correctOnRetry,
        displayNotStartedStudents: sessionReportOptions.displayNotStartedStudents,
        scoreNotStarted: sessionReportOptions.scoreNotStarted,
        scoreStartedNotCompletedIncorrect: sessionReportOptions.scoreStartedNotCompletedIncorrect,
        scoreUnscoredCRZero: sessionReportOptions.scoreUnscoredCRZero,
        totals: sessionReportOptions.totals,
        correctIncorrectRetry: sessionReportOptions.correctIncorrectRetry,
        standards: sessionReportOptions.standards,
        units: sessionReportOptions.units,
        themes: sessionReportOptions.themes,
        levels: sessionReportOptions.levels,
        attributes: sessionReportOptions.attributes,
        individualResults: sessionReportOptions.individualResults,
        questions: sessionReportOptions.questions,
        answerDistribution: sessionReportOptions.answerDistribution,
        fromDate: sessionReportOptions.fromDate,
        toDate: sessionReportOptions.toDate
      },
      {
        reportOptionType: 1,
        isRetakeReport: isRetakeReport
      }
    ];

    try {
      setReportOptions(option).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const checkBoxInput = [
    {
      id: 'displayNotStartedStudents',
      label: studentId ? 'Display retakes that have not been started' : `Display students who have not started the ${headerOptions.isAssessment ? 'assessment' : 'assignment'}`,
      checked: sessionReportOptions?.displayNotStartedStudents,
      toolTip:
        `When checked all students will display regardless of if they started the ${headerOptions.isAssessment ? 'assessment' : 'assignment'}, but results will not be scored unless you check options below.`
    },
    {
      id: 'scoreNotStarted',
      label: `Score ${headerOptions.isAssessment ? 'assessments' : 'assignments'} that have not been started`,
      checked: sessionReportOptions?.scoreNotStarted,
      toolTip: `Any ${headerOptions.isAssessment ? 'assessments' : 'assignments'} that have not been started will be scored as 0.`
    },
    {
      id: 'scoreStartedNotCompletedIncorrect',
      label: `Score ${headerOptions.isAssessment ? 'assessments' : 'assignments'} that have been started but not completed`,
      checked: sessionReportOptions?.scoreStartedNotCompletedIncorrect,
      toolTip:
        `Any incomplete questions on ${headerOptions.isAssessment ? 'assessments' : 'assignments'} that have been started will be calculated as incorrect.`
    },
    {
      id: 'scoreUnscoredCRZero',
      label: 'Score un-scored CR questions as 0 points',
      checked: sessionReportOptions?.scoreUnscoredCRZero,
      toolTip:
        'Any un-scored constructed response question will be scored as 0, regardless of if the student answered it.'
    }
  ];

  const allCredits = [
    {
      id: 1,
      name: 'No Credits'
    },
    {
      id: 2,
      name: 'Half Credits'
    },
    {
      id: 3,
      name: 'Full Credits'
    }
  ];

  const includeReportCheckBox = [
    [
      {
        id: 'totals',
        label: 'Totals',
        checked: sessionReportOptions?.totals,
        hide: false
      },
      {
        id: 'correctIncorrectRetry',
        label: 'Correct/Incorrect',
        checked: sessionReportOptions?.correctIncorrectRetry,
        hide: false
      },
      {
        id: 'standards',
        label: 'Standards',
        checked: sessionReportOptions?.standards,
        hide: false
      },
      {
        id: 'units',
        label: 'Topics',
        checked: sessionReportOptions?.units,
        hide: false
      },
      {
        id: 'questions',
        label: 'Questions',
        checked: sessionReportOptions?.questions,
        hide: (isTeacherReport && reportContext?.isAllReport) || studentToIncludeTab == 2
      }
    ],
    [
      {
        id: 'themes',
        label: 'Tags',
        checked: sessionReportOptions?.themes,
        hide: false
      },
      {
        id: 'levels',
        label: 'Levels',
        checked: sessionReportOptions?.levels,
        hide: false
      },
      {
        id: 'attributes',
        label: 'Attributes',
        checked: sessionReportOptions?.attributes,
        hide: false
      },
      {
        id: 'individualResults',
        label: 'Individual Result',
        checked: sessionReportOptions?.individualResults,
        hide: (isTeacherReport && reportContext?.isAllReport) || studentToIncludeTab == 2
      },
      {
        id: 'answerDistribution',
        label: 'Answer Distribution',
        checked: sessionReportOptions?.questions ? sessionReportOptions?.answerDistribution : false,
        hide: (isTeacherReport && reportContext?.isAllReport) || studentToIncludeTab == 2 || isRetakeReport
      }
    ]
  ];

  function extractRowData(row) {
    const rowData = [];
    const cells = row.querySelectorAll('td, th');
    cells.forEach((cell) => {
      rowData.push(cell.textContent.trim());
    });
    return rowData;
  }

  const exportHandler = async () => {
    let newUpdatedData = [...copyData];
    let questionsList = [];
    newUpdatedData?.forEach((item, index) => {
      let data = [];
      if (index === 0) {
        data = mergeObjectsByNumber(
          item.questions,
          selectedCreditId,
          'questions',
          sessionReportOptions
        );
      }
      if (sessionReportOptions?.questions && item?.questions && index === 0 && studentToIncludeTab != 2 && (isTeacherReport ? !reportContext?.isAllReport : true)) {
        data?.questions?.forEach((questionData) => {
          questionsList.push({
            Score: Math.round(questionData?.score),
            Correct: Math.round(questionData?.correct),
            Incorrect: Math.round(questionData?.inCorrect),
            'Correct on Retry': questionData?.correctOnRetry,
            'CR Answered': questionData?.crAnswered,
            'Question(with answer distribution)':
              sessionReportOptions?.answerDistribution &&
                questionData?.mcChoiceDistribution?.choices?.length > 0
                ? questionData?.mcChoiceDistribution?.choices
                  ?.map((value, index) => {
                    return (
                      (cumilativeReportData?.properties?.mcStyleIsAlphabet
                        ? String.fromCharCode(65 + index)
                        : index + 1) +
                      ':' +
                      (value !== undefined ? value : '0')
                    );
                  })
                  .join(', ')
                  .replace(/,/g, ' ') +
                (
                  ',' +
                  (questionData?.standards && questionData?.standards.length > 0
                    ? questionData?.standards[0].description
                    : '') +
                  ' - ' +
                  (questionData?.standards && questionData?.standards.length > 0
                    ? questionData?.standards[0].standardNumber
                    : '')
                ).replace(/,/g, ' ')
                : '<Fill-in or CR>' +
                (
                  ',' +
                  (questionData?.standards && questionData?.standards.length > 0
                    ? questionData?.standards[0].description
                    : '') +
                  ' - ' +
                  (questionData?.standards && questionData?.standards.length > 0
                    ? questionData?.standards[0].standardNumber
                    : '')
                ).replace(/,/g, ' ')
          });
        });
      }
    });

    if (copyData?.length > 1) {
      newUpdatedData?.forEach((item) => {
        if (item.topics?.length > 0) {
          item.topics = mergeObjectsByNumber(
            item.topics,
            selectedCreditId,
            'topics',
            sessionReportOptions
          );
        }
        if (item.standards?.length > 0) {
          item.standards = mergeObjectsByNumber(
            item.standards,
            selectedCreditId,
            'standards',
            sessionReportOptions
          );
        }
        if (item.tags?.length > 0) {
          item.tags = mergeObjectsByNumber(
            item.tags,
            selectedCreditId,
            'tags',
            sessionReportOptions
          );
        }
        if (item.level?.length > 0) {
          item.level = mergeObjectsByNumber(
            item.level,
            selectedCreditId,
            'level',
            sessionReportOptions
          );
        }
        if (item.attribute?.length > 0) {
          item.attribute = mergeObjectsByNumber(
            item.attribute,
            selectedCreditId,
            'attribute',
            sessionReportOptions
          );
        }
        if (item.totals?.length > 0) {
          item.totals = mergeObjectsByNumberforExport(
            item.totals,
            selectedCreditId,
            'totals',
            sessionReportOptions
          );
        }
      });
    } else {
      newUpdatedData.forEach((item) => {
        if (item.topics?.length > 0) {
          item.topics = mergeObjectsByNumber(
            item.topics,
            selectedCreditId,
            'topics',
            sessionReportOptions
          );
        }
        if (item.standards?.length > 0) {
          item.standards = mergeObjectsByNumber(
            item.standards,
            selectedCreditId,
            'standards',
            sessionReportOptions
          );
        }
        if (item.tags?.length > 0) {
          item.tags = mergeObjectsByNumber(
            item.tags,
            selectedCreditId,
            'tags',
            sessionReportOptions
          );
        }
        if (item.level?.length > 0) {
          item.level = mergeObjectsByNumber(
            item.level,
            selectedCreditId,
            'level',
            sessionReportOptions
          );
        }
        if (item.attribute?.length > 0) {
          item.attribute = mergeObjectsByNumber(
            item.attribute,
            selectedCreditId,
            'attribute',
            sessionReportOptions
          );
        }
        if (item.totals?.length > 0) {
          item.totals = mergeObjectsByNumberforExport(
            item.totals,
            selectedCreditId,
            'totals',
            sessionReportOptions
          );
        }
      });
    }
    let data;
    let newData;

    if (copyData.length > 1) {
      data = removePropertiesFromObjects(newUpdatedData);
      for (const key in data) {
        for (const mainKey in data[key]) {
          if (data[key][mainKey].hasOwnProperty(mainKey)) {
            const mainValue = data[key][mainKey];

            for (const item of mainValue[mainKey]) {
              const capitalizedKey = capitalizeFirstLetter(mainKey);
              if (item.score) {
                item.score = typeof item.score === 'number' ? Math.round(item.score) : item.score;
              }
              if (capitalizedKey === 'Standards') {
                item[capitalizedKey] = `${item.description}:${item.standardNumber}`;
                delete item.standardNumber;
              }
              if (capitalizedKey === 'Totals') {
                item[capitalizedKey] = '';
              } else {
                if (capitalizedKey === 'Topics') {
                  const descriptionString = convertHtmlToPlainText(item.description);
                  // Replace multiple spaces with a single space
                  item[capitalizedKey] = descriptionString.replace(/\s+/g, ' ');
                  delete item.description;
                } else {
                  item[capitalizedKey] = item.description;
                  delete item.description;
                }
              }
            }
          }
        }
      }
      if (copyData.length == 2)
        newData = [data[0], data[1]];
      else
        newData = [data[0], data[1], data[2]];
    } else {
      data = removePropertiesFromObjects(newUpdatedData);

      for (const key in data) {
        for (const mainKey in data[key]) {
          if (data[key][mainKey].hasOwnProperty(mainKey)) {
            const mainValue = data[key][mainKey];
            for (const item of mainValue[mainKey]) {
              const capitalizedKey = capitalizeFirstLetter(mainKey);
              if (item.score) {
                item.score = typeof item.score === 'number' ? Math.round(item.score) : item.score;
              }
              if (capitalizedKey === 'Standards') {
                item[capitalizedKey] = `${item.description}:${item.standardNumber}`;
                delete item.standardNumber;
              } else if (capitalizedKey === 'Topics') {
                const descriptionString = convertHtmlToPlainText(item.description);
                // Replace multiple spaces with a single space
                item[capitalizedKey] = descriptionString.replace(/\s+/g, ' ');
                delete item.description;
              } else {
                item[capitalizedKey] = item.description;
                delete item.description;
              }
            }
          }
        }
      }

      newData = { ...data };
    }
    let resultArray = [];
    if (cumilativeReportData.studentResults?.length > 0 && document.getElementById('individualQuestionReportTable')) {
      const tableElement = document.getElementById('individualQuestionReportTable');
      const heading = extractRowData(tableElement.querySelector('tr.table-head'));
      const rows = tableElement.querySelectorAll('tr.table-body');
      const tableData = [];
      rows.forEach((row) => {
        tableData.push(extractRowData(row));
      });
      const tableJSON = {
        heading: heading,
        data: tableData
      };
      tableJSON.data.map((item) => item[0].replace(/,/g, ''));
      resultArray = tableJSON.data.map((row) =>
        row.reduce((obj, value, index) => {
          const key = tableJSON.heading[index];
          let convertedValue = index === 0 ? value.replace(/,/g, '') : value;
          value;
          if (value === 'Correct') {
            convertedValue = 'C';
          } else if (value === 'Incorrect') {
            convertedValue = 'X';
          } else if (value === 'Correct on Retry') {
            convertedValue = 'R';
          }
          obj[key] = convertedValue;
          return obj;
        }, {})
      );
    }

    // Add new properties to the new object
    let newObjectWithNewProperties = {
      Report: headerOptions.reportTitle,
      Course: headerOptions.isSelfStudyCumulative ? selfStudyFilters?.courseHeader : cumilativeReportData?.course,
      'Correct on Retry': creditName,
      Teacher: cumilativeReportData?.teacher,
      Class: headerOptions.isSelfStudyCumulative ? selfStudyFilters?.classHeader : cumilativeReportData?.class,
      'Report Date': DateFormatter.toShortDate2(cumilativeReportData?.reportDate, true),
      Student: getStudentName()
    };
    if (headerOptions.showReportType)
      newObjectWithNewProperties = { ...newObjectWithNewProperties, Assignment: cumilativeReportData?.assignment };
    if (!headerOptions.showClassName)
      delete newObjectWithNewProperties['Class'];
    if (!headerOptions.showStudentName)
      delete newObjectWithNewProperties['Student'];
    if (isTeacherReport && reportContext?.isAllReport) {
      var questionsIncludedName = '';
      switch(questionCategory){
      case 0:
        questionsIncludedName = 'Assigned';
        break;
      case 1:
        questionsIncludedName = 'Self-Generated';
        break;
      case 2:
        questionsIncludedName = 'All';
        break;
      default:
        questionsIncludedName = 'Unknown';
        break;
      }
      newObjectWithNewProperties = { ...newObjectWithNewProperties, 'Questions Included': questionsIncludedName};
    }

    if (!showRetryOptions) delete newObjectWithNewProperties['Correct on Retry'];

    let updatedArrayForCsv;

    if (copyData.length > 1) {
      updatedArrayForCsv = {
        Totals: [
          {
            score: mainTotalTableData.totals?.score
              ? typeof mainTotalTableData.totals.score === 'number'
                ? Math.round(mainTotalTableData.totals.score)
                : mainTotalTableData.totals.score
              : '',
            correct: mainTotalTableData.totals?.correct ? mainTotalTableData.totals?.correct : '',
            incorrect: mainTotalTableData.totals?.inCorrect
              ? mainTotalTableData.totals?.inCorrect
              : '',
            correctOnRetry: mainTotalTableData.totals?.correctOnRetry
              ? mainTotalTableData.totals?.correctOnRetry
              : '',
            crAnswered: mainTotalTableData.totals?.crAnswered
              ? mainTotalTableData.totals?.crAnswered
              : ''
          }
        ],
        'By Questions': questionsList
      };
      if ((isTeacherReport && reportContext?.isAllReport) || studentToIncludeTab == 2) delete updatedArrayForCsv['By Questions'];
      newData?.map((item, index) => {
        const { attribute, level, standards, tags, topics, ...dataObject } = item;
        updatedArrayForCsv[item.courseName] = {
          Totals: item.totals,
          'By Topics': topics,
          'By Tags': tags,
          'By Difficulty Level': level,
          'By Attribute': attribute,
          'By Standard': standards
        };
      });
    } else {
      const { attribute, level, standards, tags, topics, ...dataObject } = newData[0];
      updatedArrayForCsv = {
        Totals: [
          {
            score: mainTotalTableData.totals?.score ? typeof mainTotalTableData.totals.score === 'number'
              ? Math.round(mainTotalTableData.totals.score)
              : mainTotalTableData.totals.score
              : '',
            correct: mainTotalTableData.totals?.correct,
            incorrect: mainTotalTableData.totals?.inCorrect,
            correctOnRetry: mainTotalTableData.totals?.correctOnRetry,
            crAnswered: mainTotalTableData.totals?.crAnswered
          }
        ],
        'By Questions': questionsList,
        'By Topics': topics.topics,
        'By Tags': tags.tags,
        'By Difficulty Level': level.level,
        'By Attribute': attribute.attribute,
        'By Standard': standards.standards
      };
      if ((isTeacherReport && reportContext?.isAllReport) || studentToIncludeTab == 2) delete updatedArrayForCsv['By Questions'];
    }

    if (copyData.length > 1) {
      for (const key in updatedArrayForCsv) {
        if (updatedArrayForCsv.hasOwnProperty(key)) {
          const value = updatedArrayForCsv[key];
          if (!sessionReportOptions?.units) {
            delete value['By Topics'];
          }
          if (!sessionReportOptions?.levels) {
            delete value['By Difficulty Level'];
          }

          if (!sessionReportOptions?.attributes) {
            delete value['By Attribute'];
          }

          if (!sessionReportOptions?.standards) {
            delete value['By Standard'];
          }

          if (!sessionReportOptions?.themes) {
            delete value['By Tags'];
          }
          if (!sessionReportOptions?.questions) {
            delete value['By Questions'];
          }
        }
      }
    } else {
      if (!sessionReportOptions?.units) {
        delete updatedArrayForCsv['By Topics'];
      }

      if (!sessionReportOptions?.levels) {
        delete updatedArrayForCsv['By Difficulty Level'];
      }

      if (!sessionReportOptions?.attributes) {
        delete updatedArrayForCsv['By Attribute'];
      }

      if (!sessionReportOptions?.standards) {
        delete updatedArrayForCsv['By Standard'];
      }

      if (!sessionReportOptions?.themes) {
        delete updatedArrayForCsv['By Tags'];
      }
      if (!sessionReportOptions?.questions) {
        delete updatedArrayForCsv['By Questions'];
      }
    }
    updatedArrayForCsv.ReportOptions = newObjectWithNewProperties;
    if (cumilativeReportData.studentResults?.length > 0 && !reportContext?.isAllReport && (studentId || sessionReportOptions?.individualResults) && !headerOptions.isSelfStudyCumulative) {
      const { Totals, ...restOfCsv } = updatedArrayForCsv;
      updatedArrayForCsv = { Totals, IndividualQuestionResult: resultArray, ...restOfCsv };
    }
    const newDataWithReportOptionsFirst = reorderObjectProperties(
      updatedArrayForCsv,
      'ReportOptions'
    );
    if (!sessionReportOptions?.scoreUnscoredCRZero) {
      delete newDataWithReportOptionsFirst['Teacher Questions - Short Answer '];
    }
    let footerMessage = showRetryOptions ? `\n\nQuestions marked as R (Correct On Retry) are counted as ${creditName == 'No Credits'
      ? 'incorrect'
      : creditName === 'Half Credits'
        ? 'Half Credit'
        : 'Full Credit'
    }  in the scoring.` : '';

    if (!sessionReportOptions.displayNotStartedStudents) {
      footerMessage +=
        '\nStudents who have not started the assignment are not included in the report.';
    }

    const csvData = convertToCSV(newDataWithReportOptionsFirst, footerMessage);
    downloadCSV(csvData, exportFileName);
  };

  const handlePrint = async () => {
    if(isPdfGenerating) return;

    setShowReportOptions(true);
    const contentWrapper = document.getElementById('cumulative_pdf_Wrapper');
    const htmlString = contentWrapper.innerHTML;

    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = htmlString;

    const svgElements = tempContainer.querySelectorAll('svg');

    svgElements.forEach((svgElement) => {
      if (svgElement.classList.contains('fa-circle-question')) {
        svgElement.classList.add('d-none');
      } else if (svgElement.classList.contains('svg-inline--fa')) {
        svgElement.classList.remove('fa-check');
        svgElement.classList.remove('fa-xmark');
        svgElement.style.width = '10px';
      }
    });

    const selects = tempContainer.querySelectorAll('select');
    selects.forEach((select) => {
      select.style.backgroundImage = 'none';
      select.style.width = '200px';
    });

    const reportOptionsDiv = tempContainer.querySelector('#reportOptionsDiv');
    if (reportOptionsDiv) {
      reportOptionsDiv.classList.add('d-none');
    }

    const creditDropDownSelect = tempContainer.querySelector('#creditDropDown');
    if (creditDropDownSelect) {
      creditDropDownSelect.classList.add('d-none');
    }

    const creditNameTextBox = tempContainer.querySelector('#creditNameTextBox');
    if (creditNameTextBox) {
      if (creditNameTextBox.classList.contains('d-none')) {
        creditNameTextBox.classList.remove('d-none');
      }
    }
    const courseheader = tempContainer.querySelector('#selfstudyCourseHeader');
    if (courseheader) {
      if (courseheader.classList.contains('text-truncate')) {
        courseheader.classList.remove('text-truncate');
      }
    }
    const classheader = tempContainer.querySelector('#selfstudyClassHeader');
    if (classheader) {
      if (classheader.classList.contains('text-truncate')) {
        classheader.classList.remove('text-truncate');
      }
    }

    const classDropDown = tempContainer.querySelector('#classDropDown');
    if (classDropDown) {
      classDropDown.classList.add('d-none');
    }

    const classSelectTextBox = tempContainer.querySelector('#classSelectTextBox');
    if (classSelectTextBox) {
      if (classSelectTextBox.classList.contains('d-none')) {
        classSelectTextBox.classList.remove('d-none');
      }
    }

    const vacabulary_study_sheetDiv = tempContainer.querySelector('#vacabulary_study_sheetDiv');
    if (vacabulary_study_sheetDiv) {
      vacabulary_study_sheetDiv.classList.add('d-none');
    }

    const tableProperties = tempContainer.querySelectorAll('.report-properties');
    tableProperties.forEach(el => {
      el.classList.remove('d-none');
    });
    const noPrintDivs = tempContainer.querySelectorAll('.no-print');
    noPrintDivs.forEach(el => {
      el.classList.add('d-none');
    });
    addCustomCheckboxClass(tempContainer);

    if (isRetakeReport) {
      if (displayRetakeVersion == 'original') {
        var bestRetakeRadio = tempContainer.querySelector('#bestRetakeRadio');
        var origianlAssignmentRadio = tempContainer.querySelector('#origianlAssignmentRadio');
        bestRetakeRadio.removeAttribute('checked');
        origianlAssignmentRadio.setAttribute('checked', '');
      } else {
        var bestRetakeRadio = tempContainer.querySelector('#bestRetakeRadio');
        var origianlAssignmentRadio = tempContainer.querySelector('#origianlAssignmentRadio');
        bestRetakeRadio.setAttribute('checked', '');
        origianlAssignmentRadio.removeAttribute('checked');
      }
    }

    const buttonElements = tempContainer.querySelectorAll('button');
    buttonElements.forEach((svgElement) => {
      svgElement.classList.add('d-none');
    });

    
    const pdfStyles = `<style>
  .table-container {
    overflow: visible !important;
    max-width: none !important;
    width: 100% !important;
  }

  .individualQuestionTable,
  .singleStudentIndividualQuestionTable,
  .print-question-table {
    width: 100% !important;
    table-layout: fixed !important;
    margin-bottom: 50px !important;
    overflow: visible !important;
  }

  .individualQuestionTable td,
  .individualQuestionTable th,
  .singleStudentIndividualQuestionTable td,
  .singleStudentIndividualQuestionTable th,
  .print-question-table td,
  .print-question-table th {
    position: static !important;
    min-width: unset !important;
    max-width: unset !important;
  }

  .individualQuestionTable table,
  .singleStudentIndividualQuestionTable table,
  .print-question-table table {
    width: 100% !important;
    table-layout: fixed !important;
    border-collapse: collapse !important;
  }

  .individualQuestionTable tr,
  .singleStudentIndividualQuestionTable tr,
  .print-question-table tr {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }

  #colorCodeLegend {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }

  .thead-fixed th {
    position: static !important;
  }
  </style>`;
    handleTablePrint(tempContainer);

    await printPDF(exportFileName, pdfStyles + tempContainer.innerHTML, PageSize.A3);
  };

  const handleTablePrint= (tempContainer) =>{
    const tableEl = tempContainer.querySelector('#individualQuestionReportTable');
    if (tableEl) {
      const headerRow = tableEl.querySelector('thead tr');
      const allHeaders = Array.from(headerRow.querySelectorAll('th'));
      const questionIndices = [];
      const fixedStartIndices = [];
      const fixedEndIndices = [];
      let foundFirstQuestion = false;

      allHeaders.forEach((th, index) => {
        if (/^Q\d+$/.test(th.textContent.trim())) {
          questionIndices.push(index);
          foundFirstQuestion = true;
        } else if (!foundFirstQuestion) {
          fixedStartIndices.push(index);
        } else {
          fixedEndIndices.push(index);
        }
      });

      const chunkSize = 10;
      const rowsPerPage = 15;
      const allBodyRows = Array.from(tableEl.querySelectorAll('tbody tr'));
      const isVerticalQuestionTable = questionIndices.length === 0;
      const needsColumnSplit = questionIndices.length > chunkSize;
      const needsRowSplit = !isVerticalQuestionTable && allBodyRows.length > rowsPerPage;
      if (needsColumnSplit || needsRowSplit) {
        const tableContainer = tableEl.closest('.table-container') || tableEl.parentElement;
        const parent = tableContainer.parentElement;

        const columnGroups = [];
        if (needsColumnSplit) {
          for (let i = 0; i < questionIndices.length; i += chunkSize) {
            columnGroups.push(questionIndices.slice(i, i + chunkSize));
          }
        } else {
          columnGroups.push(questionIndices);
        }

        columnGroups.forEach(chunk => {
          const colIndices = [...fixedStartIndices, ...chunk, ...fixedEndIndices];

          for (let r = 0; r < allBodyRows.length; r += rowsPerPage) {
            const rowsForPage = allBodyRows.slice(r, r + rowsPerPage);

            const newTable = tempContainer.ownerDocument.createElement('table');
            newTable.className = tableEl.className;
            newTable.style.width = '100%';
            newTable.style.tableLayout = 'fixed';

            const newThead = tempContainer.ownerDocument.createElement('thead');
            const newHeaderRow = tempContainer.ownerDocument.createElement('tr');
            newHeaderRow.className = headerRow.className;
            colIndices.forEach(ci => newHeaderRow.appendChild(allHeaders[ci].cloneNode(true)));
            newThead.appendChild(newHeaderRow);
            newTable.appendChild(newThead);

            const newTbody = tempContainer.ownerDocument.createElement('tbody');
            rowsForPage.forEach(row => {
              const cells = Array.from(row.querySelectorAll('td'));
              const newRow = tempContainer.ownerDocument.createElement('tr');
              newRow.className = row.className;
              colIndices.forEach(ci => {
                if (cells[ci]) newRow.appendChild(cells[ci].cloneNode(true));
              });
              newTbody.appendChild(newRow);
            });
            newTable.appendChild(newTbody);

            const newContainer = tempContainer.ownerDocument.createElement('div');
            newContainer.className = tableContainer.className;
            newContainer.classList.add('print-question-table');
            newContainer.style.overflow = 'visible';
            newContainer.style.marginBottom = '30px';
            newContainer.appendChild(newTable);

            parent.insertBefore(newContainer, tableContainer);
          }
        });
        tableContainer.remove();
      }
    }
  };

  const additionOptionInputValueHandler = (value, option) => {
    const parsedValue = parseInt(value);
    if (value !== '' && (!Number.isInteger(parsedValue) || parsedValue < 0 || parsedValue > 99)) {
      // If the value is not empty and not an integer within the range (0 to 99), return early without updating state.
      return;
    }
    setChangingReportOptions(true);
    const updatedSessionReportOptions = {
      ...sessionReportOptions,
      [option]: value === '' ? '' : parsedValue
    };
    setSessionReportOptions(updatedSessionReportOptions);
  };

  const excludedStudentsHandler = () => {
    let excludedStudents = [];
    cumilativeReportData?.studentResults?.map((item) => {
      if (!item.assignmentStarted && !sessionReportOptions.displayNotStartedStudents) {
        excludedStudents.push(item);
      }
    });
    setExcludedStudents(excludedStudents);
  };

  const getStudentName = () => {
    if(headerOptions.isSelfStudyCumulative)
      return selfStudyFilters.studentName;
    else
      return cumilativeReportData?.studentResults[0]?.name.replace(',', '');
  };

  const setStudentResults = ()=>{
    if(isRetakeReport && headerOptions.reportTitle == 'Class Retake Report' && displayRetakeVersion == 'bestScore'){
      let newReportData = {
        ...cumilativeReportData,
        studentResults : cumilativeReportData.bestResults
      };
      return cumulativeIndividualScore(newReportData,sessionReportOptions);
    }
    return cumilativeReportData;
  };

  const setCompletedCount = ()=>{
    if(isRetakeReport && headerOptions.reportTitle == 'Class Retake Report' && displayRetakeVersion == 'bestScore'){
      return { ...cumilativeReportData, completedCount : cumilativeReportData.bestCompletedCount, completedPercentage: cumilativeReportData.bestCompletedPercentage};
    }
    return { ...cumilativeReportData };
  };

  const handleExpand = (elementId) => {
    setExpandElements(prev =>
      prev.includes(elementId)
        ? prev.filter(id => id !== elementId)
        : [...prev, elementId]
    );
  };

  return (
    <div className="white-card" id="cumulative_pdf_Wrapper">
      <Header
        classList={classList}
        sessionReportOptions={sessionReportOptions}
        exportHandler={exportHandler}
        printHandler={handlePrint}
        details={setCompletedCount()}
        isPdfGenerating={isPdfGenerating}
        headerOptions={{ ...headerOptions, showRetryInfo: showRetryOptions }}
        classChangeHandler={(e) => handleClassSelectionChange(e)}
        selectedClassId={selectedClassIds}
        retryCreditName={creditName}
        isAllStudentReport={isTeacherReport && studentToIncludeTab == 0}
        isAllTeacherReport={isTeacherReport && reportContext?.isAllReport}
        timePeriod={(isTeacherReport && reportContext?.isAllReport) ? `${DateFormatter.toShortDate2(reportContext?.startDate)} to ${DateFormatter.toShortDate2(reportContext?.endDate)}` : ''}
        isLoading={reportOptionloader}
        selectedClassName={isTeacherReport ? reportContext?.className : null}
        selectedQuestionsCategory={questionCategory}
        selfStudyFilters={selfStudyFilters}
      />

      {isRetakeReport && studentId && cumilativeReportData !== null &&
        <div className='d-flex flex-row'>
          <div className='mr-25'>
            <span className='fw-bold me-2'>Student Name:</span>
            <span>{!ferpaEnabled ? 'hidden' : cumilativeReportData.studentResults?.find(f => f)?.name}</span>
          </div>

          <div className='mr-25'>
            <span className='fw-bold me-2'>Student ID:</span>
            <span>{!ferpaEnabled ? 'hidden' : studentId}</span>
          </div>

          <div className='mr-25'>
            <span className='fw-bold me-2'>Best Score:</span>
            <span>
              {(() => {
                const score = cumilativeReportData.studentResults?.find(f => f.bestScore)?.score;
                const actualScore = Number(score);
                return Number.isFinite(actualScore) ? actualScore.toFixed(0) : score;
              })()}
            </span>

          </div>

          <div className='mr-25'>
            <span className='fw-bold me-2'>Number of Retakes:</span>
            <span>{cumilativeReportData.studentResults.find(f => f)?.numberOfRetakes}</span>
          </div>
        </div>
      }

      {isRetakeReport &&
        <>
          {loader ? (
            <SkeletonGrid
              rowCount={1}
              colCount={1}/>
          ):(
            <>
              <Form.Label
                style={{ fontSize: '14px', fontWeight: 'bold' }}
                className="text-color"
                htmlFor="assignmentResultsRadio">
                Display results for:
              </Form.Label>
              <Form.Group id="assignmentResultsRadio" className='w-100'>
                <Form.Check
                  inline
                  label="Original Assignment"
                  name="assignmentRadioGroup"
                  type="radio"
                  id="origianlAssignmentRadio"
                  defaultChecked="true"
                  onChange={() => setDisplayRetakeVersion('original')}
                  className='w-20'
                />
                <Form.Check
                  inline
                  label="Best Retake Assignment"
                  name="assignmentRadioGroup"
                  type="radio"
                  id="bestRetakeRadio"
                  onChange={() => setDisplayRetakeVersion('bestScore')}
                  className='w-20'
                />
              </Form.Group></>
          )}

        </>
      }


      {excludedStudents.length > 0 && cumilativeReportData !== null && (
        <div className="row">
          <p
            className=" mt-3"
            style={{
              fontWeight: '400',
              fontSize: '16px'
            }}>
            Excluded Students
          </p>
          <p style={{ fontWeight: 400, fontSize: '14px' }}>
            The following students have been excluded from the report based on your preferences
            below.
          </p>

          <div className="col-lg-3">
            <table id="excludedStudentsTable" className={'table reportTable w-100'}>
              <thead>
                <tr className="table-head">
                  <th className="text-center">Name</th>
                  <th className="text-center">Student ID</th>
                </tr>
              </thead>
              <tbody>
                {excludedStudents.map((item, index) => {
                  return (
                    <tr className="table-body"
                      key={index}>
                      <td className="text-center">
                        {item.name}
                      </td>
                      <td className="text-center">
                        {item.identification}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className="mt-5 d-flex justify-content-between">
        <div className="d-flex">
          <div className="indicator-blue"></div>
          <p className="mx-1">{`>= ${isNaN(sessionReportOptions?.passingScore) ? 0 : sessionReportOptions?.passingScore}%`} </p>
          <div className="indicator-red mx-1"></div>
          <p className="mx-1">{`< ${isNaN(sessionReportOptions?.passingScore) ? 0 : sessionReportOptions?.passingScore}%`}</p>
        </div>
        <div id="reportOptionsDiv" className="d-flex align-item-center report-button" style={{ cursor: 'pointer' }} onClick={() => cumilativeReportData !== null && !cumilativeReportData.error ? setShowReportOptions(!showReportOptions) : undefined}>
          Report Options
          <FontAwesomeIcon icon={showReportOptions ? faMinus : faPlus} className={'ms-2'} />
        </div>
      </div>

      {showReportOptions && reportOptionloader && (
        <div className="mt-3 report_option_details fade show">
          <div className="leftSide w-100">
            {[...Array(8)].map((_, index) => (
              <div key={index}>
                <Skeleton />
              </div>
            ))}
          </div>
          <div className="rightSide w-100">
            {[...Array(5)].map((_, index) => (
              <div key={index}>
                <Skeleton />
              </div>
            ))}
          </div>
        </div>
      )}
      {!reportOptionloader &&
        <ReportOptions
          key={dateTimeBasedUniqueKey}
          expand={showReportOptions}
          checkBoxInput={reportOptions?.hideDisplayNotStartedStudents ?checkBoxInput.slice(1) : checkBoxInput}
          includeReportCheckBox={includeReportCheckBox}
          reportChangeHandler={reportChangeHandler}
          handleCheckBonInput={handleCheckBonInput}
          handleReportDateChange={handleReportDateChange}
          sessionReportOptions={sessionReportOptions}
          handleSelectCredits={handleSelectCredits}
          allCredits={allCredits}
          selectedCreditId={selectedCreditId}
          setSelectedCreditId={setSelectedCreditId}
          additionOptionInputValueHandler={additionOptionInputValueHandler}
          creditName={creditName}
          showRetryOptions={showRetryOptions}
          showTimePeriod={reportOptions?.showTimePeriod}
          singleStudent={studentId ? true : false}
          showQuestionCategory={isTeacherReport && reportContext?.isAllReport}
          setQuestionCategory={setQuestionCategory}
          questionCategory={questionCategory}
          handleQuestionCategory={handleQuestionCategory}
          isRetakeReport={isRetakeReport}
          reportTitle ={headerOptions.reportTitle}
          isAssessment={headerOptions.isAssessment}
          isSelfStudyCumulative={headerOptions.isSelfStudyCumulative}
        />
      }

      {loader && (
        <>
          <div className='mb-4'>
            <SkeletonGrid rowCount={1} colCount={4} className={'mt-5 p-2'} />
          </div>
          {[...Array(3)].map((_, index) => (
            <div key={'Skl' + index} className='mt-4'>
              <TableSkeleton key={index} rowCount={4} colCount={6} />
            </div>
          ))}
        </>
      )}

      {cumilativeReportData !== null && (
        <>
          {sessionReportOptions?.totals && (
            <Totals
              studentSessionReport={cumilativeReportData}
              sessionReportOptions={sessionReportOptions}
              details={mainTotalTableData}
              hideRetries={!showRetryOptions}
              displayRetakeVersion={displayRetakeVersion}
              isTeacherReport={isTeacherReport}
              reportType={isTeacherReport ? reportContext?.reportType : ''}
            />
          )}
          {((sessionReportOptions?.individualResults && !reportContext?.isAllReport) || (studentToIncludeTab == 2 && isTeacherReport && !reportContext?.isAllReport)) && cumilativeReportData.studentResults?.length > 0 && !headerOptions.hideIndividualResults &&
                <>
                  {assignmentNotStarted && isTeacherReport && !reportContext?.isAllReport &&
                    <p className='mt-5'>
                      There are no answers in the specified time period.
                    </p>}

                  {individualResultsOrientation === 'vertical' ?
                    <IndividualQuestionTableVertical
                      details={setStudentResults()}
                      mainTotalTableData={mainTotalTableData}
                      sessionReportOptions={sessionReportOptions}
                      retryScoringOptionId={selectedCreditId}
                      showRetryOptions={true}
                    /> :
                    <IndividualQuestionTable
                      details={setStudentResults()}
                      sessionReportOptions={sessionReportOptions}
                      mainTotalTableData={mainTotalTableData}
                      isRetakeReport={isRetakeReport}
                      singleStudent={studentId ? true : false}
                      showRetryOptions={showRetryOptions}
                      retakeAssignmentToShow={displayRetakeVersion}
                      retryScoringOptionId={selectedCreditId}
                      selectedClassId={selectedClassIds}
                    />}
                </>
          }
          {copyData?.map((item, index) => {
            return (
              <>
                {sessionReportOptions?.questions && item?.questions?.length > 0 && studentToIncludeTab != 2 && (isTeacherReport ? !reportContext?.isAllReport : true) && (
                  <Table
                    elementId={`questions_${index}`}
                    expandElements={expandElements}
                    title="Questions"
                    handleExpand={handleExpand}
                    details={item?.questions}
                    selectedCreditId={selectedCreditId}
                    setUpdatedData={setUpdatedData}
                    titleName="questions"
                    initialData={copyData}
                    cumilativeReport={true}
                    mcStyleAlphabet={cumilativeReportData?.properties?.mcStyleIsAlphabet}
                    sessionReportOptions={sessionReportOptions}
                    hideRetiesColumn={!showRetryOptions}
                  />
                )}
                {copyData.length > 1 &&
                      item.totals?.length > 0 &&
                      item?.totals.filter(
                        (x) =>
                          x.correct !== 0 ||
                          x.inCorrect !== 0 ||
                          x.correctOnRetry !== 0 ||
                          x.crAnswered !== 0
                      ).length > 0 ? (
                    <>
                      <p
                        className="p-3 mt-3"
                        style={{
                          background: '#f0f2f8'
                        }}>
                        <strong>{item?.courseName}</strong>
                      </p>
                      <Table
                        elementId={`totals_${index}`}
                        expandElements={expandElements}
                        handleExpand={handleExpand}
                        title="Totals"
                        setUpdatedData={setUpdatedData}
                        titleName="totals"
                        details={item.totals}
                        selectedCreditId={selectedCreditId}
                        sessionReportOptions={sessionReportOptions}
                        initialData={copyData}
                        hideRetiesColumn={!showRetryOptions}
                        isAllReport={isTeacherReport && reportContext?.isAllReport}
                      />
                    </>
                  ):(<>
                    {copyData.length > 1 && headerOptions.isSelfStudyCumulative &&
                        <p
                          className="p-3 mt-3"
                          style={{
                            background: '#f0f2f8'
                          }}>
                          <strong>{item?.courseName}</strong>
                        </p>
                    }
                  </>
                  )}

                {sessionReportOptions?.units &&
                      item?.topics?.length > 0 &&
                      item.topics.filter(
                        (x) =>
                          x.correct !== 0 ||
                          x.inCorrect !== 0 ||
                          x.correctOnRetry !== 0 ||
                          x.crAnswered !== 0
                      ).length > 0 && (
                  <Table
                    elementId={`topics_${index}`}
                    expandElements={expandElements}
                    title="By Topics"
                    handleExpand={handleExpand}
                    details={item?.topics}
                    selectedCreditId={selectedCreditId}
                    setUpdatedData={setUpdatedData}
                    titleName="topics"
                    initialData={copyData}
                    sessionReportOptions={sessionReportOptions}
                    hideRetiesColumn={!showRetryOptions}
                  />
                )}
                {sessionReportOptions?.themes &&
                      item?.tags?.length > 0 &&
                      item.tags.filter(
                        (x) =>
                          x.correct !== 0 ||
                          x.inCorrect !== 0 ||
                          x.correctOnRetry !== 0 ||
                          x.crAnswered !== 0
                      ).length > 0 && (
                  <Table
                    elementId={`tags_${index}`}
                    expandElements={expandElements}
                    title="By Tags"
                    handleExpand={handleExpand}
                    details={item?.tags}
                    selectedCreditId={selectedCreditId}
                    setUpdatedData={setUpdatedData}
                    titleName="tags"
                    initialData={copyData}
                    sessionReportOptions={sessionReportOptions}
                    hideRetiesColumn={!showRetryOptions}
                  />
                )}
                {sessionReportOptions?.levels &&
                      item?.level?.length > 0 &&
                      item?.level.filter(
                        (x) =>
                          x.correct !== 0 ||
                          x.inCorrect !== 0 ||
                          x.correctOnRetry !== 0 ||
                          x.crAnswered !== 0
                      ).length > 0 && (
                  <Table
                    elementId={`levels_${index}`}
                    expandElements={expandElements}
                    title="By Difficulty Level"
                    handleExpand={handleExpand}
                    details={item?.level}
                    selectedCreditId={selectedCreditId}
                    setUpdatedData={setUpdatedData}
                    titleName="level"
                    initialData={copyData}
                    sessionReportOptions={sessionReportOptions}
                    hideRetiesColumn={!showRetryOptions}
                  />
                )}

                {sessionReportOptions?.attributes &&
                      item?.attribute?.length > 0 &&
                      item.attribute.filter(
                        (x) =>
                          x.correct !== 0 ||
                          x.inCorrect !== 0 ||
                          x.correctOnRetry !== 0 ||
                          x.crAnswered !== 0
                      ).length > 0 && (
                  <Table
                    elementId={`attributes_${index}`}
                    expandElements={expandElements}
                    title="By Attributes"
                    handleExpand={handleExpand}
                    details={item?.attribute}
                    selectedCreditId={selectedCreditId}
                    setUpdatedData={setUpdatedData}
                    titleName="attribute"
                    initialData={copyData}
                    sessionReportOptions={sessionReportOptions}
                    hideRetiesColumn={!showRetryOptions}
                  />
                )}
                {sessionReportOptions?.standards &&
                      item?.standards?.length > 0 &&
                      item?.standards.filter(
                        (x) =>
                          x.correct !== 0 ||
                          x.inCorrect !== 0 ||
                          x.correctOnRetry !== 0 ||
                          x.crAnswered !== 0
                      ).length > 0 && (
                  <Table
                    elementId={`standards_${index}`}
                    expandElements={expandElements}
                    title="By Standard"
                    handleExpand={handleExpand}
                    details={item?.standards}
                    standard={true}
                    selectedCreditId={selectedCreditId}
                    setUpdatedData={setUpdatedData}
                    titleName="standards"
                    initialData={copyData}
                    sessionReportOptions={sessionReportOptions}
                    hideRetiesColumn={!showRetryOptions}
                  />
                )}
              </>
            );
          })}

        </>
      )}
    </div>
  );
};

QuestionsBreakdownReport.propTypes = {
  isRetakeReport: PropTypes.bool,
  studentId: PropTypes.number,
  initialClassId: PropTypes.number,
  exportFileName: PropTypes.string,
  isTeacherReport: PropTypes.bool,
  reportDataEndpoint: PropTypes.func,
  individualResultsOrientation: PropTypes.string,
  studentToIncludeTab: PropTypes.number,
  headerOptions: PropTypes.object,
  reportOptions: PropTypes.object,
  retryCreditId: PropTypes.number
};

export default QuestionsBreakdownReport;
